module.exports = __webpack_public_path__ + "img/whiteTriangule.cf8350f3.svg";